define(function (require) {

    // Initialize the olark chat client
    require('../olark');

    var $ = require('jquery'),
        svgReplace = require('./svg-replacer'),
        selectors = {
            doc: 'html',
            svgs: 'img[src$=".svg"]',
            mobileMenuButton: '.ko-nav-mobile-menu-button',
            navLink: '.ko-nav-main-item a[href^="#"]',
            navLabel: '.ko-nav-label',
            navIcon: '.ko-nav-icon',
            teamSwitcher: '.ko-nav-team',
            teamName: '.ko-nav-team-name',
            subNavHeading: '.ko-sub-nav-heading',
            subNavHeadingTeam: '.ko-sub-nav-heading-current-team',
        },
        classes = {
            android: 'android-stock',
            windows: 'windows-phone',
            leftMenuIsOpen: 'ko-sidemenu-left-is-open',
            subNavActive: 'ko-nav-sub-is-active',
            teamSwitcherActive: 'ko-nav-teamswitcher-is-active',
        },
        directions = {
            left: 'left',
            right: 'right',
        },

        // Android stock browser can't translateX with percentages, so we need a class to reference in the CSS
        nua = navigator.userAgent,
        isAndroidStock = nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1,
        isWindowsPhone = nua.indexOf('IEMobile') > -1;

	var messageMyTeam = require('../../silver-plus/message-my-team');

  $(function() {
  	messageMyTeam.init();

    if (isAndroidStock) {
        $(selectors.doc).addClass('android-stock');
    }

    if (isWindowsPhone) {
        $(selectors.doc).addClass('windows-phone');
    }

    // Fix IE10 Mobile's handling of device-width viewports (which is a bug (that they're fixing (?))).
    //  Via: http://timkadlec.com/2013/01/windows-phone-8-and-device-width/
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
        var msViewportStyle = document.createElement('style');
        msViewportStyle.appendChild(
            document.createTextNode(
                '@-ms-viewport{width:auto!important}'
            )
        );
        document.getElementsByTagName('head')[0].
            appendChild(msViewportStyle);
    }


    // Click the main menu button and show the menu
    $(selectors.mobileMenuButton).click(function () {
        $(selectors.doc).toggleClass(classes.leftMenuIsOpen);
    });

    // Function for shuttling the nav left and right.
    // heading = the selector with the text you want for the heading of the subnav
    // headingSelector = the class of the header at the top of the submenu list
    // self = a little trick to maintain context with the click event
    var shuttleNav = function (heading, classToAdd, headingSelector, leftOrRight, self) {
        var headingText = $(self).children(heading).html(); // get the text from the top level nav item
        var theList = $(self).parent().children('ul'); // get the relevant subnav <ul>

        $(selectors.doc).addClass(classToAdd);

        theList.addClass(classToAdd);

        if (leftOrRight === directions.left) {
            theList.prepend('<a href="#" class="ko-sub-nav-heading"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" baseProfile="basic" id="Layer_1" x="0px" y="0px" viewBox="0 0 612 792" xml:space="preserve"><path fill="#231F20" d="M267,396l289.1,290.5L450.1,792L55.9,396L450.1,0l106,105.5L267,396z"></path></svg>' + headingText + '</a>');
        } else if (leftOrRight === directions.right) {
            theList.prepend('<a class="ko-sub-nav-heading-current-team">' + headingText + '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" baseProfile="basic" id="Layer_1" x="0px" y="0px" viewBox="0 0 612 792" xml:space="preserve"><path fill="#231F20" d="M55.9,105.5L161.9,0l394.1,396L161.9,792l-106-105.5L345,396L55.9,105.5z"></path></svg></a>');
        }

        theList.find(selectors.navIcon).each(svgReplace);

        theList.one('click', headingSelector, function () {
            $(selectors.doc).removeClass(classToAdd);
            theList.removeClass(classToAdd);
            // remove the back label after the animation is done. animation duration is $t-quick in _variables.scss
            $(headingSelector).delay(200).queue(function (next) {
                $(this).remove();
                next();
            });
        });
    };

    // Actually run the function on the appropriate buttons
    $(selectors.navLink).click(function () {
        var self = this;
        shuttleNav(selectors.navLabel, classes.subNavActive, selectors.subNavHeading, directions.left, self);
    });

    // Actually run the function on the appropriate buttons
    $(selectors.teamSwitcher).click(function () {
        var self = this;

        var teamList = $(self).parent().children('ul.ko-nav-sub.ko-nav-teamswitcher')[0];

        //Checking if the user is associated with multiple teams or not
        if ($(teamList).children('li').length == 0) {
            return;
        }

        shuttleNav(selectors.teamName, classes.teamSwitcherActive, selectors.subNavHeadingTeam, directions.right, self);
    });
  });
});
